<template>
  <main>
    <v-container fluid class="pa-5 pb-16 elevation-1">
      <!-- Título que abarca horizontalmente -->
      <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
        <h1 class="text-h4 font-weight-bold">Usuarios Calendar</h1>
      </v-sheet>

      <!-- Tabla de usuarios -->
      <v-card elevation="2" class="pa-4 mt-5">
        <v-card-text>
          <v-text-field
            v-model="search"
            label="Buscar"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            class="w-50"
            hide-details
            single-line
          ></v-text-field>

          <v-data-table
            :headers="headers"
            :items="usuarios"
            :items-per-page="5"
            :search="search"
            class="elevation-1"
            show-expand
          >
            <template v-slot:headers>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Email</th>
                <th>Información</th>
              </tr>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.nombre }}</td>
                <td>{{ item.email }}</td>
                <td>
                  <v-btn icon @click="verUsuario(item)">
                    <v-tooltip text="Ver Informacion del usuario">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props">mdi-book-settings </v-icon>
                      </template>
                    </v-tooltip>
                  </v-btn>
                </td>
              </tr>
            </template>
            <!-- Fila expandida -->
            <template v-slot:expanded-row="{ item }">
              <tr>
                <td colspan="5">
                  <v-card flat class="pa-3">
                    <p><strong>ID:</strong> {{ item.id }}</p>
                    <p><strong>Nombre:</strong> {{ item.nombre }}</p>
                    <p><strong>Email:</strong> {{ item.email }}</p>
                    <!-- Puedes agregar más info aquí -->
                  </v-card>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </main>
</template>

<script>
import api from "@/api/axios/axios.js";

export default {
  name: "DashboardCalendar",
  data() {
    return {
      usuarios: [],
      search: "",
    };
  },
  created() {
    this.getUserApiCalendar();
  },

  methods: {
    verUsuario(item) {
      this.$router.push({
        name: "userDash",
        params: { id: item.id, name: item.nombre, email: item.email },
      });
    },
    async getUserApiCalendar() {
      try {
        const response = await api.get(
          "http://localhost:8005/login/userCalendar/",
        );
        //console.log(response);
        this.usuarios = response.data.map((u, index) => ({
          id: index + 1,
          nombre: `${u.nombre} ${u.apellido}`,
          email: u.email,
        }));
      } catch (err) {
        //console.log("Error al Obtener usuarios", err);
      }
    },
  },
};
</script>

<style scoped>
.v-app {
  display: inline-block; /* Hace que el v-app solo ocupe el espacio necesario */
  width: 100%; /* Opcional: Si quieres que ocupe todo el ancho disponible */
  padding: 0; /* Sin padding para que el v-app ajuste su tamaño exactamente al contenido */
}
</style>
